module.exports = __webpack_public_path__ + "img/file----818@1x.5b03c208.png";